import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';

import { FuseSharedModule } from '@fuse/shared.module';

import { FuseSidebarModule } from '@fuse/components';
import {AcademyCoursesComponent} from "./centers/centers.component";
import {AcademyCoursesService} from "./centers.service";
import {AcademyCourseComponent} from "./center/center.component";
import {AcademyCourseService} from "./course.service";
// import {AngularFireStorageModule} from '@angular/fire/storage';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import { NewrcenterComponent } from './newrcenter/newrcenter.component';
import { AuthGuard } from '../../auth/auth.guard';
import { TranslateModule } from '@ngx-translate/core';

const routes = [
    {
        path     : 'centers',
        component: AcademyCoursesComponent,
        resolve  : {
            academy: AcademyCoursesService
        }
    },
    {
        path     : 'centers/:courseId/:courseSlug',
        component: AcademyCourseComponent,
        resolve  : {
            academy: AcademyCourseService
        }
    },
    {
        path      : '**',
        redirectTo: 'courses'
    },

    {
        path     : 'rcenter/newrc',
        component: NewrcenterComponent,
        canActivate: [AuthGuard],
    },

];

@NgModule({
    declarations: [
        AcademyCoursesComponent,
        AcademyCourseComponent,
        NewrcenterComponent
    ],
    imports     : [
        RouterModule.forChild(routes),

        MatButtonModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatSelectModule,

        FuseSharedModule,
        FuseSidebarModule,
        // AngularFireStorageModule,
        MatProgressSpinnerModule,
        TranslateModule
    ],
    providers   : [
        AcademyCoursesService,
        AcademyCourseService
    ]
})
export class RcenterModule
{
}
